import React from "react";
import { StatusBadge } from "@/components/ui/status-badge";
import { CaseStatus } from "../../api/types/case";
import { CASE_STATUS_TONE } from "../case/caseStatusColors";

interface StatusTagProps {
  status: CaseStatus;
}

export const StatusTag: React.FC<StatusTagProps> = ({ status }) => (
  <StatusBadge tone={CASE_STATUS_TONE[status] ?? "neutral"} dot>
    {status}
  </StatusBadge>
);
